import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Route, Redirect } from "react-router-dom";

import {
  selectCurrentUser,
  selectToken,
} from "../../redux/user/userSelectors";

const ProtectedRoute = ({
  token,
  currentUser,
  component: Component,
  render,
  children,
  requiredRoles,
  ...rest
}) => {
  const hasRequiredRole =
    !requiredRoles ||
    requiredRoles.length === 0 ||
    requiredRoles.some((role) => currentUser?.roles?.includes(role));

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!token) {
          return <Redirect to="/login" />;
        }

        if (!hasRequiredRole) {
          return <Redirect to="/" />;
        }

        if (Component) {
          return <Component {...props} />;
        }

        if (render) {
          return render(props);
        }

        if (typeof children === "function") {
          return children(props);
        }

        return children || null;
      }}
    />
  );
};

const mapStateToProps = createStructuredSelector({
  token: selectToken,
  currentUser: selectCurrentUser,
});

export default connect(mapStateToProps)(ProtectedRoute);
